import { render, staticRenderFns } from "./individualization.vue?vue&type=template&id=1fb70d9a&scoped=true"
import script from "./individualization.vue?vue&type=script&lang=js"
export * from "./individualization.vue?vue&type=script&lang=js"
import style0 from "./individualization.vue?vue&type=style&index=0&id=1fb70d9a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb70d9a",
  null
  
)

export default component.exports